export enum TriggeringProcessEnum {
  INITIAL = 'Online Erfassung - Kundeneingabe',
  EDITED = 'Online Erfassung - Kundenprofiländerung',
  RENEWED_INPUT = 'Online Erfassung - Neuerliche Kundeneingabe',
}
